import { render, staticRenderFns } from "./KaitouToolbarVertical.vue?vue&type=template&id=71a6c062&scoped=true&"
import script from "./KaitouToolbarVertical.vue?vue&type=script&lang=ts&"
export * from "./KaitouToolbarVertical.vue?vue&type=script&lang=ts&"
import style0 from "./KaitouToolbarVertical.vue?vue&type=style&index=0&id=71a6c062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6c062",
  null
  
)

export default component.exports